import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'

import dashboard from './dashboard'
import violationHistory from './violationHistory'
import login from './login'

// import { auth } from './auth'

export default combineReducers({
    // auth,
    login,
    dashboard,
    violationHistory,
    routing: routerReducer
})



// WEBPACK FOOTER //
// ./src/reducers/index.ts